export abstract class BaseModel {
    id?: number;
}
